import { render, staticRenderFns } from "./AssetComponentWidget.vue?vue&type=template&id=6ed5a68c&"
import script from "./AssetComponentWidget.vue?vue&type=script&lang=js&"
export * from "./AssetComponentWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports